export default function (userInfo, setUser, serverOrigin) {
	return new Promise((resolve, reject) => {
		let body = JSON.stringify(userInfo);
		fetch(serverOrigin + '/signup', {
			method: 'post',
			credentials: 'include',
			headers: {'Content-Type': 'application/json'},
			body: body,
		})
			.then(res => {
				return res.json();
			})
			.then(user => {
				setUser(user);
				console.log('Successfully ran sign up request with server');
				localStorage.setItem('userID', user._id);
				resolve(user);
			})
			.catch(err => {
				console.error('Something went worng in client sign up fetch because ' + err.message);
				reject({
					message: 'Something went worng in client sign up fetch because ' + err.message,
				});
			});
	});
}
